import { fetchWithToken, postWithToken } from "../authentication/AuthProvider";
import config from "../config";


//  Building routes function (keeps your existing pattern)
export const building_routes = (building) => ({
  label: "Building",
  root: building,
  new: building + "/new",
  delete: building + "/delete",
  update: building + "/update",
  archive: building + "/archive",
  unarchive: building + "/unarchive",
  hide: building + "/hide",
  unhide: building + "/unhide",
  get_hidden: building + "/get_hidden",
  duplicate: building + "/duplicate",
  duplicate_from_template: building + "/duplicate_from_template",
  save_building_info: building + "/save_building_info",
  save_scope_and_goals: building + "/save_scope_and_goals",
  save_supplier_info: building + "/save_supplier_info",
  get_photo: building + "/get_photo",
  get_spec_document: building + "/get_spec_document",
  get_safety_document: building + "/get_safety_document",
  get_from_admin: building + "/get_from_admin",
  get_non_archive_by_user_id: building + "/get_non_archive_by_user_id",
  get_mine_archive: building + "/get_mine_archive",
  get_total_gwp: building + "/get_total_gwp",
  get_total_gwp_transport: building + "/get_total_gwp_transport",
  get_total_gwp_material: building + "/get_total_gwp_material",
  get_total_gwp_energy: building + "/get_total_gwp_energy",
  get_total_gwp_stage_a1_a3: building + "/get_total_gwp_stage_a1_a3",
  get_total_gwp_stage_a4_a5: building + "/get_total_gwp_stage_a4_a5",
  get_total_gwp_stage_b1_b5: building + "/get_total_gwp_stage_b1_b5",
  get_total_gwp_stage_b6_b7: building + "/get_total_gwp_stage_b6_b7",
  get_total_gwp_stage_c: building + "/get_total_gwp_stage_c",
  get_total_gwp_stage_d: building + "/get_total_gwp_stage_d",
  get_insight: building + "/get_insight",
  generate_insight_3_5: building + "/generate_insight_3_5",
  generate_insight_5_0: building + "/generate_insight_5_0",
  generate_insight_deepseek: building + "/generate_insight_deepseek",
  generate_insight_gemini_flash: building + "/generate_insight_gemini_flash",
  generate_insight_gemini_flash_lite: building + "/generate_insight_gemini_flash_lite",
  generate_insight_gemini_pro: building + "/generate_insight_gemini_pro",
  get_by_id: building + "/get_by_id",
});


//  Building API object
export const Building = {
  get label() {
    return config.building.label;
  },
  value: "building",

  // ===== CRUD Operations =====
  new: (data) => postWithToken(config.building.new, data),  // Backend gets user_id from JWT

  delete: (ids) => postWithToken(config.building.delete, { ids }),

  update: (building) => postWithToken(config.building.update, building),

  archive: (ids) => postWithToken(config.building.archive, { ids }),

  unarchive: (ids) => postWithToken(config.building.unarchive, { ids }),

  hide: (ids) => postWithToken(config.building.hide, { ids }),

  unhide: (ids) => postWithToken(config.building.unhide, { ids }),

  get_hidden: () => postWithToken(config.building.get_hidden),

  // ===== Duplicate Operations =====
  duplicate: (ids) => postWithToken(config.building.duplicate, { ids }),

  duplicate_from_template: (ids) => postWithToken(config.building.duplicate_from_template, { ids }),

  // ===== Get Operations =====
  get_from_admin: () => postWithToken(config.building.get_from_admin),

  get_non_archive_by_user_id: () => postWithToken(config.building.get_non_archive_by_user_id),

  get_mine_archive: () => postWithToken(config.building.get_mine_archive),

  get_mine: () => postWithToken(config.building.root + "/get_non_archive_by_user_id"),

  //  File retrieval (GET requests)
  get_photo: (id) => fetchWithToken(`${config.building.get_photo}?id=${id}`, config.method.GET),

  get_spec_document: (id) => fetchWithToken(`${config.building.get_spec_document}?id=${id}`, config.method.GET),

  get_safety_document: (id) => fetchWithToken(`${config.building.get_safety_document}?id=${id}`, config.method.GET),

  // ===== GWP Total and Category Operations =====
  get_total_gwp: (ids) => postWithToken(config.building.get_total_gwp, { ids }),

  get_total_gwp_transport: (ids) => postWithToken(config.building.get_total_gwp_transport, { ids }),

  get_total_gwp_material: (ids) => postWithToken(config.building.get_total_gwp_material, { ids }),

  get_total_gwp_energy: (ids) => postWithToken(config.building.get_total_gwp_energy, { ids }),

  // ===== GWP Lifecycle Stage Operations =====
  get_total_gwp_stage_a1_a3: (ids) => postWithToken(config.building.get_total_gwp_stage_a1_a3, { ids }),

  get_total_gwp_stage_a4_a5: (ids) => postWithToken(config.building.get_total_gwp_stage_a4_a5, { ids }),

  get_total_gwp_stage_b1_b5: (ids) => postWithToken(config.building.get_total_gwp_stage_b1_b5, { ids }),

  get_total_gwp_stage_b6_b7: (ids) => postWithToken(config.building.get_total_gwp_stage_b6_b7, { ids }),

  get_total_gwp_stage_c: (ids) => postWithToken(config.building.get_total_gwp_stage_c, { ids }),

  get_total_gwp_stage_d: (ids) => postWithToken(config.building.get_total_gwp_stage_d, { ids }),

  // ===== Global View Aggregated Data =====
  get_global_view_data: (ids) => postWithToken(config.building.root + "/get_global_view_data", { ids }),

  // ===== Save Operations (FormData) =====
  save_building_info: (form) => fetchWithToken(
    config.building.save_building_info,
    { ...config.method.POST, body: form }
  ),

  save_scope_and_goals: (form) => fetchWithToken(
    config.building.save_scope_and_goals,
    { ...config.method.POST, body: form }
  ),

  save_supplier_info: (form) => fetchWithToken(
    config.building.save_supplier_info,
    { ...config.method.POST, body: form }
  ),
  get_results: (building_id) =>
    postWithToken(config.building.root + "/get_results", { building_id }),

  get_insight: (building_id) => postWithToken(config.building.get_insight, { building_id }),
  generate_insight_3_5: (building_id) => postWithToken(config.building.generate_insight_3_5, { building_id }),
  generate_insight_5_0: (building_id) => postWithToken(config.building.generate_insight_5_0, { building_id }),
  generate_insight_deepseek: (building_id) => postWithToken(config.building.generate_insight_deepseek, { building_id }),
  generate_insight_gemini_flash: (building_id) => postWithToken(config.building.generate_insight_gemini_flash, { building_id }),
  generate_insight_gemini_flash_lite: (building_id) => postWithToken(config.building.generate_insight_gemini_flash_lite, { building_id }),
  generate_insight_gemini_pro: (building_id) => postWithToken(config.building.generate_insight_gemini_pro, { building_id }),
  request_validation: (ids) => postWithToken(config.building.root + "/request_validation", { ids }),
  set_validation_status: ({ id, validation_status }) => postWithToken(config.building.root + "/set_validation_status", { id, validation_status }),
  retrieve: (ids) => postWithToken(config.building.root + "/retrieve", { ids }),
  get_by_id: (id) => postWithToken(config.building.get_by_id, { id }),
};
